"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/map");

var _flagsInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flags");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getFlightsResponse = exports.getFlightsEpic = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));

var _fluxStandardAction = require("flux-standard-action");

var _Observable = require("rxjs/Observable");

var _fromPromise = require("rxjs/observable/fromPromise");

var _operators = require("rxjs/operators");

var _featureFlags = require("../../../feature-flags");

var _ILoading = require("../../../models/ILoading");

var _observableErrorHandler = require("../../../redux/observableErrorHandler");

var _UserActions = require("../../models/UserActions");

var _userRegistry = require("../userRegistry");

var getFlightsEpic = function getFlightsEpic(action$) {
  return action$.ofType(_UserActions.UserActions.getFlights).pipe((0, _operators.switchMap)(function (action) {
    if (process.env.APP_ENABLE_FLIGHTING !== 'true' || process.env.APP_DEV_ENABLE_MOCKS === 'true') {
      return _Observable.Observable.of({
        type: _UserActions.UserActions.getFlightsResponse,
        payload: new _set.default()
      });
    }

    return (0, _fromPromise.fromPromise)(_flagsInstanceProperty(_featureFlags).getFlags()).pipe((0, _mapInstanceProperty(_operators))(function (flights) {
      return {
        type: _UserActions.UserActions.getFlightsResponse,
        payload: flights
      };
    }), (0, _operators.catchError)((0, _observableErrorHandler.errorHandler)(_UserActions.UserActions.getFlightsFailed, action)));
  }));
};

exports.getFlightsEpic = getFlightsEpic;

_userRegistry.userRegistry.addEpic('getFlightsEpic', getFlightsEpic);

var getFlightsResponse = function getFlightsResponse(state, action) {
  var flights;

  if (!(0, _fluxStandardAction.isError)(action)) {
    flights = action.payload;
  }

  if (flights === undefined) {
    flights = new _set.default();
  }

  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    flights: {
      value: flights,
      isLoading: false,
      loadingState: _ILoading.LoadingState.loaded
    }
  });
  return nextState;
};

exports.getFlightsResponse = getFlightsResponse;

_userRegistry.userRegistry.add(_UserActions.UserActions.getFlightsResponse, getFlightsResponse);

_userRegistry.userRegistry.add(_UserActions.UserActions.getFlightsFailed, getFlightsResponse);